import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const MARKETING = [
  { key: "footer.home", href: "https://www.grantonomy.de" },
  { key: "footer.services", href: "https://www.grantonomy.de/leistungen" },
  { key: "footer.contact", href: "https://www.grantonomy.de/kontakt" },
  { key: "footer.about", href: "https://www.grantonomy.de/ueber-uns" },
  { key: "footer.projects", href: "https://www.grantonomy.de/projekte" },
  { key: "footer.imprint", href: "https://www.grantonomy.de/impressum" },
] as const;

export function AppFooter({ className }: { className?: string }) {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="app-footer" className={cn("app-footer site-footer no-print", className)}>
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <span className="site-footer__wordmark">Grantonomy</span>
          </div>
          <nav className="site-footer__links" aria-label={t("footer.navAria")}>
            {MARKETING.map((item) => (
              <a
                key={item.key}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer__link"
              >
                {t(item.key)}
              </a>
            ))}
          </nav>
        </div>
      </div>
      <div className="site-footer__legal">
        <span>{t("footer.copyright", { year })}</span>
        <span>{t("footer.product")}</span>
      </div>
    </footer>
  );
}
